import React from 'react';

const About = () => {
  return (
    <div className="container" style={{ maxWidth: '800px', margin: '20px auto', padding: '20px' }}>
      <h1>About ASMR.guru</h1>
      <p>Welcome to ASMR.guru, your premier destination for discovering and enjoying the best ASMR content on the web.</p>
      <p>ASMR (Autonomous Sensory Meridian Response) is a tingling sensation that typically begins on the scalp and moves down the back of the neck and upper spine. It&apos;s triggered by various auditory or visual stimuli, often described as a relaxing and pleasurable experience.</p>
      <h2>Our Mission</h2>
      <p>We curate and showcase high-quality ASMR videos from talented creators across YouTube, making it easy for you to find content that helps you relax, focus, or fall asleep.</p>
      <h2>What We Offer</h2>
      <ul>
        <li>Curated collections of top ASMR videos</li>
        <li>Easy navigation and discovery</li>
        <li>Regular updates with the latest content</li>
        <li>Categories tailored to different ASMR preferences</li>
      </ul>
    </div>
  );
};

export default About;